import {
  aristocratGabonStgId,
  aristocratPremierbetAngolaProdId,
  aristocratPremierbetCameroonProdId,
  aristocratPremierbetChadProdId,
  aristocratPremierbetCongoProdId,
  aristocratPremierbetEthiopiaProdId,
  aristocratPremierbetGuineaProdId,
  aristocratPremierbetIvoryCoastProdId,
  aristocratPremierbetLiberiaProdId,
  aristocratPremierbetMalawiProdId,
  aristocratPremierbetMaliProdId,
  aristocratPremierbetMozambiqueProdId,
  aristocratPremierbetNamibiaProdId,
  aristocratPremierbetSenegalProdId,
  aristocratPremierbetSierraLeoneProdId,
  aristocratPremierbetTanzaniaProdId,
  aristocratPremierbetUgandaProdId,
  aristocratZimbabweStgId,
  bet9jaAgentProdId,
  bet9jaAgentStgId,
  bet9jaProdId,
  bet9jaShopAppProdId,
  bet9jaShopAppStgId,
  bet9jaStgId,
  gamingHubProdId,
  gamingHubStgId,
  gliCertificationStgId,
  mamabetProdId,
  mamabetStgId,
  maybetsKenyaProdId,
  maybetsKenyaStgId,
  mozzartbetCroatiaProdId,
  mozzartbetCroatiaStgId,
  mozzartbetProdId,
  mozzartbetSerbiaProdId,
  mozzartbetSerbiaStgId,
  mozzartbetStgId,
  premierbetProdId,
  soccerbetSerbiaProdId,
  soccerbetSerbiaStgId,
  spinAndWinProdId,
  spinAndWinStgId,
  teapuestoPeruProdId,
  teapuestoPeruStgId,
  teapuestoProdId,
  teapuestoStgId,
  yaJuegoProdId,
  yaJuegoStgId,
} from '../../config'
import { OrgIdTypeEnum } from '../../containers/Sidebar/trading/types'

export const orgIdGroups: { [key in OrgIdTypeEnum]: string[] } = {
  [OrgIdTypeEnum.BET9JA]: [bet9jaProdId, bet9jaStgId],
  [OrgIdTypeEnum.YAJUEGO]: [yaJuegoProdId, yaJuegoStgId],
  [OrgIdTypeEnum.MOZZARTBET]: [mozzartbetStgId, mozzartbetProdId],
  [OrgIdTypeEnum.MOZZARTBET_SERBIA]: [
    mozzartbetSerbiaStgId,
    mozzartbetSerbiaProdId,
  ],
  [OrgIdTypeEnum.MOZZARTBET_CROATIA]: [
    mozzartbetCroatiaStgId,
    mozzartbetCroatiaProdId,
  ],
  [OrgIdTypeEnum.GLI]: [gliCertificationStgId],
  [OrgIdTypeEnum.TEAPUESTO]: [teapuestoProdId, teapuestoStgId],
  [OrgIdTypeEnum.SOCCERBET_SERBIA]: [
    soccerbetSerbiaStgId,
    soccerbetSerbiaProdId,
  ],
  [OrgIdTypeEnum.MAYBETS_KENYA]: [maybetsKenyaStgId, maybetsKenyaProdId],
  [OrgIdTypeEnum.MAMABET]: [mamabetStgId, mamabetProdId],
  [OrgIdTypeEnum.TEAPUESTO_PERU]: [teapuestoPeruStgId, teapuestoPeruProdId],
  [OrgIdTypeEnum.SPIN_AND_WIN]: [spinAndWinStgId, spinAndWinProdId],
  [OrgIdTypeEnum.BET9JA_SHOP_APP]: [bet9jaShopAppStgId, bet9jaShopAppProdId],
  [OrgIdTypeEnum.GAMING_HUB]: [gamingHubStgId, gamingHubProdId],
  [OrgIdTypeEnum.ARISTOCRAT_ZIMBABWE]: [aristocratZimbabweStgId],
  [OrgIdTypeEnum.ARISTOCRAT_GABON]: [aristocratGabonStgId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_CAMEROON]: [aristocratPremierbetCameroonProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_MALAWI]: [aristocratPremierbetMalawiProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_UGANDA]: [aristocratPremierbetUgandaProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_CONGO]: [aristocratPremierbetCongoProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_SIERRA_LEONE]: [aristocratPremierbetSierraLeoneProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_SENEGAL]: [aristocratPremierbetSenegalProdId],
  [OrgIdTypeEnum.PREMIERBET]: [premierbetProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_CHAD]: [aristocratPremierbetChadProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_MOZAMBIQUE]: [aristocratPremierbetMozambiqueProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_MALI]: [aristocratPremierbetMaliProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_ANGOLA]: [aristocratPremierbetAngolaProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_TANZANIA]: [aristocratPremierbetTanzaniaProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_GUINEA]: [aristocratPremierbetGuineaProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_LIBERIA]: [aristocratPremierbetLiberiaProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_ETHIOPIA]: [aristocratPremierbetEthiopiaProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_IVORY_COAST]: [aristocratPremierbetIvoryCoastProdId],
  [OrgIdTypeEnum.ARISTOCRAT_PREMIERBET_NAMIBIA]: [aristocratPremierbetNamibiaProdId],
  [OrgIdTypeEnum.BET9JA_AGENT]: [bet9jaAgentStgId, bet9jaAgentProdId],
}

const parseOrgId = (
  organizationId: string | undefined,
): OrgIdTypeEnum | undefined => {
  if (!organizationId) {
    return undefined
  }
  for (const orgType in orgIdGroups) {
    if (orgIdGroups[orgType as OrgIdTypeEnum].includes(organizationId)) {
      return orgType as OrgIdTypeEnum
    }
  }
}

export default parseOrgId
